import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

export default {
  getProjects(endpoint, cb) {
    axios
      .get(endpoint)
      .then(({ data }) => {
        cb(data);
      })
      .catch((err) => {
        if (err.response && err.response.status == 404) {
          return;
        }
        handleAxiosError(err);
      });
  },

  getProjectDetail(endpoint, cb) {
    axios
      .get(endpoint)
      .then(({ data }) => {
        cb(data.data);
      })
      .catch((err) => {
        if (err.response && err.response.status == 404) {
          return;
        }
        handleAxiosError(err);
      });
  },
};
